import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { login } from '../../service/utenti';
import { useDispatch } from 'react-redux';
import { setUser } from '../../redux/userSlice';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

function Copyright(props: any) {
  return (
    <div style={{alignContent: 'center', justifyContent: 'center', alignItems: 'center', width: '100%', display:'flex', flexDirection:'column'}}>
      <img src={require("../../assets/images/caramellamultimedia-logo.png")} style={{width: 80, marginTop:20}} />
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://porrinigroup.it/">
          Porrini Group
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </div>
  );
}

export default function Login(props: any) {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {

    event.preventDefault();
    const data = new FormData(event.currentTarget);

    try {

      const username: string | undefined = data.get('username')?.toString();
      const password: string | undefined = data.get('password')?.toString();
      const loginResult = await login(username, password);

      dispatch(setUser(loginResult.user_data)); 

      navigate("/")

    } catch(err: any) {

      enqueueSnackbar(err.message ? err.message : err, { variant: 'error' }); 

    }
    
  };

  return (
    <Container  component="main" maxWidth="xs" >
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img src={require("../../assets/images/logo-appello.png")} style={{width: 200}} />
        <br /><br />
        <Typography component="h1" variant="h5">
          Accedi
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
          >
            Accedi
          </Button>
        </Box>
      </Box>
      <Copyright sx={{ mt: 4, mb: 4 }} />
    </Container>
  );
}

function dispatch(arg0: Promise<any>) {
  throw new Error('Function not implemented.');
}
